export default "__VITE_ASSET__D9$ywSQE__"